import { differenceInCalendarDays, startOfDay } from 'date-fns';
import { getTransferDisplayAtIso } from '../inventory-transfers/transferDisplayDate';
import type { InventoryItem } from '../../types/inventory';

/**
 * Días calendario completos desde la fecha efectiva de transferencia (misma lógica que
 * "Fecha Transfer." en tablas) hasta hoy, en hora local.
 * Sin transfer ni firstAssignedAt → null.
 */
export function calendarDaysSinceInventoryTransfer(item: InventoryItem): number | null {
  const iso =
    getTransferDisplayAtIso(item.transfer, item.firstAssignedAt) ?? item.firstAssignedAt ?? null;
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const anchor = startOfDay(d);
  const today = startOfDay(new Date());
  return differenceInCalendarDays(today, anchor);
}

/**
 * Días calendario desde la fecha de registro (REG completado / createdAt mapeado) hasta hoy.
 */
export function calendarDaysSinceRegistration(item: InventoryItem): number | null {
  const iso = item.createdAt;
  if (iso == null || iso === '') return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const anchor = startOfDay(d);
  const today = startOfDay(new Date());
  return differenceInCalendarDays(today, anchor);
}
